import { ModuleAdminPage } from "./ModuleAdminPage";
export function AdminLimitedChallengePage() { return <ModuleAdminPage title="月初爆分挑戰預留" code="limited-challenge" text="V1 預留活動日期、時間、遊戲、充值門檻、爆分門檻與審核欄位，預設不啟用。" />; }
